import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Location } from '@angular/common';
import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';

import { Observable } from 'rxjs';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

import { InvestorService, ScriptLoaderService, ClassService } from '../../../../../_services';
import { Investor } from '../../../../../_models';

@Component({
    selector: 'app-investor-form',
    templateUrl: './investor-form.component.html',
    styleUrls: ['./investor-form.component.scss']
})
export class InvestorFormComponent implements OnInit, AfterViewInit {
    static initialClass: string =
    'm-page--wide m-header--fixed m-header--fixed-mobile m-footer--push m-aside--offcanvas-default';
    form: FormGroup;
    banks: any;
    account_validation_messages = {
        'investor_name': [
            { type: 'required', message: 'Campo requerido.' },
            { type: 'minlength', message: 'El nombre debe tener minimo 3 caracteres.' }
        ],
        'lastname_father': [
            { type: 'required', message: 'Campo requerido.' },
            { type: 'minlength', message: 'Debe tener minimo 3 caracteres.' }
        ],
        'account': [
            { type: 'required', message: 'Campo requerido.' },
            { type: 'minlength', message: 'Debe tener minimo 11 caracteres.' },
            { type: 'pattern', message: 'No se aceptan caracteres especiales.' }
        ],
        'bank_id': [
            { type: 'required', message: 'Campo requerido.' }
        ],
        'telephone': [
            { type: 'required', message: 'Campo requerido.' },
        ],
        'email': [
            { type: 'required', message: 'Campo requerido.' },
            { type: 'email', message: 'Ingrese un correo valido' }
        ],
        'nationality': [
            { type: 'required', message: 'Campo requerido.' },
            { type: 'minlength', message: 'Debe tener minimo 5 caracteres.' }
        ],
        'holder': [
            { type: 'required', message: 'Campo requerido.' },
            { type: 'minlength', message: 'Debe tener minimo 3 caracteres.' }
        ],
        'clabe': [
            { type: 'required', message: 'Campo requerido.' },
            { type: 'minlength', message: 'Debe tener minimo 18 caracteres.' },
            { type: 'pattern', message: 'No se aceptan caracteres especiales.' }
        ],
        'rfc': [
            { type: 'required', message: 'Campo requerido.' },
            { type: 'minlength', message: 'Debe tener minimo 13 caracteres.' }
        ]
    };
    investorTypes = [
        { name: 'Física', value: 'FISICA' },
        { name: 'Moral', value: 'MORAL' }
    ];
    selectedType: string = 'FISICA';
    selectedBank: string = 'Seleccione un banco';
    requests$: Observable<Object>;
    formHeader = {
        icon: 'fa fa-user',
        text: 'PROPIETARIO'
    }
    individualTexts = {
        label: "Fecha de nacimiento",
        placeholder: "Fecha de nacimiento"
    }
    associationTexts = {
        label: "Fecha de inicio",
        placeholder: "Fecha de inicio"
    }
    nationalityTexts = {
        on: "Si",
        off: "No"
    }
    dataFetched: boolean = false;
    @BlockUI('loading-form') loadingForm: NgBlockUI;
    constructor(protected _script: ScriptLoaderService, protected _location: Location, fb: FormBuilder,
        protected _classService: ClassService,
        protected router: Router,
        protected investorData: Investor,
    ) {
        this.form = fb.group({
            'investor_name': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
            'lastname_father': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
            'lastname_mother': ['', Validators.compose([Validators.nullValidator])],
            'corporate_name': ['', Validators.compose([Validators.nullValidator])],
            'email': ['', Validators.compose([Validators.required, Validators.email])],
            'type': ['FISICA', Validators.compose([Validators.required])],
            'nationality': ['', Validators.compose([Validators.required,
            Validators.minLength(3)])],
            'telephone': ['', Validators.compose([Validators.required])],
            'mobile': ['', Validators.compose([Validators.nullValidator])],
            'curp': ['', Validators.compose([Validators.nullValidator])],
            'dob': ['', Validators.compose([Validators.nullValidator])],
            'bank_data': fb.group({
                'holder': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
                'bank_id': ['', Validators.compose([Validators.required])],
                'account': ['', Validators.compose([Validators.pattern('[0-9]+'), Validators.required, Validators.minLength(11)])],
                'clabe': ['', Validators.compose([Validators.pattern('[0-9]+'), Validators.required, Validators.minLength(18)])],
            }),
            'fiscal_address': fb.group({
                'rfc': ['', Validators.compose([Validators.required, Validators.minLength(13)])],
                'street': ['', Validators.compose([Validators.nullValidator])],
                'number': ['', Validators.compose([Validators.nullValidator])],
                'neighborhood': ['', Validators.compose([Validators.nullValidator])],
                'city': ['', Validators.compose([Validators.nullValidator])],
                'state': ['', Validators.compose([Validators.nullValidator])],
            }),
            'is_foreign': [false],
        });

    }

    ngOnInit() {
        this.form.get('type').valueChanges.subscribe(
            (type: string) => {
                if (type === 'Moral') {
                    this.form.get('corporate_name').setValidators([
                        Validators.required, Validators.minLength(2)]);
                } else {
                    this.form.get('corporate_name').setValidators([Validators.nullValidator]);
                }
                this.form.get('corporate_name').updateValueAndValidity();
            }
        );
        this.getBanks();
    }
    ngAfterViewInit() {
        this._script.loadScripts('app-investor-form',
            ['assets/app/js/investor.js']);
        this._classService.setClass(document.body, InvestorFormComponent.initialClass);
    }
    nationalityChange(state) {
        this.form.controls.is_foreign.setValue(state);
    }
    dateChanged(date) {
        this.form.controls['dob'].setValue(date.string);
    }
    back() {
        this._location.back();
    }
    data(data) { }
    error(error) { }
    end() { }

    //trae todos los bancos
    getBanks() {
        this.investorData.getBanks().subscribe(data => {
            this.banks = data;
        }, err => {
            console.log(err);
        }, () => {
            //this.blockUI.stop();
        });
    }



}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/investor/investor-form/investor-form.component.ts